import type { ReactNode } from 'react'
import React, { useState } from 'react'
import { Button, InputGroup } from '@systemeio/components'
import { SearchMdIcon, XCloseIcon } from '@systemeio/icons'
import { useTranslation } from 'next-i18next'
import type {
  CourseEnrollmentsFilterInterface,
  SchoolCommonEnrollmentsDataInterface,
} from '../types/school-enrollments-interface'

export const defaultFilter: CourseEnrollmentsFilterInterface = {
  searchBy: '',
}

export interface EnrollmentsTabFilterProps {
  className?: string
  filter: CourseEnrollmentsFilterInterface
  setFilter: (arg: React.SetStateAction<CourseEnrollmentsFilterInterface>) => void
}

export const EnrollmentsTabFilter = ({
  className,
  filter,
  setFilter,
}: EnrollmentsTabFilterProps): ReactNode => {
  const [nameFilter, setNameFilter] = useState<SchoolCommonEnrollmentsDataInterface['name']>(
    filter.searchBy,
  )

  const { t } = useTranslation()

  return (
    <form className={`justify-end gap-5 ${className || 'flex'}`}>
      <InputGroup.Root>
        <InputGroup.Addon align="inline-start" appearance="subtle">
          <SearchMdIcon aria-hidden="true" />
        </InputGroup.Addon>
        <InputGroup.Input
          key={'name-filter'}
          data-test-id="input-search-school-name"
          placeholder={t('global.search')}
          value={nameFilter}
          onChange={e => setNameFilter(e.target.value)}
        />
        {nameFilter !== '' && (
          <InputGroup.Addon align="inline-end" appearance="subtle">
            <Button
              type="button"
              variant="ghost-gray"
              size="icon-xs"
              aria-label={t('global.remove')}
              onClick={() => setNameFilter('')}
            >
              <XCloseIcon aria-hidden="true" />
            </Button>
          </InputGroup.Addon>
        )}
      </InputGroup.Root>
      <Button
        variant="primary"
        type="submit"
        onClick={e => {
          e.preventDefault()
          setFilter(prev => ({ ...prev, searchBy: nameFilter }))
        }}
        data-test-id="button-school-search"
      >
        <SearchMdIcon className="size-5" />
        <span className="hidden font-bold sm:block">{t('global.search')}</span>
      </Button>
    </form>
  )
}
